import React, { createContext, useContext } from 'react';

const GlobalSettingsContext = createContext({});

export const GlobalSettingsProvider = ({ children, settings }) => {
  return (
    <GlobalSettingsContext.Provider
      value={{
        settings,
      }}
    >
      {children}
    </GlobalSettingsContext.Provider>
  );
};

export const useGlobalSettings = () => useContext(GlobalSettingsContext);
